import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.757 6.423a.833.833 0 1 1-1.179-1.179l2.5-2.5a.833.833 0 0 1 1.179 0l2.5 2.5a.833.833 0 0 1-1.179 1.179L7.501 5.345V12.5a.833.833 0 0 1-1.667 0V5.345zM15.243 13.577a.833.833 0 0 1 1.179 1.179l-2.5 2.5a.833.833 0 0 1-1.179 0l-2.5-2.5a.833.833 0 0 1 1.179-1.179l1.077 1.078V7.5a.833.833 0 0 1 1.667 0v7.155z"
    }, null, -1)
  ]))]))
}
export default { render: render }